export function BrushIcon() {
  return (
    <svg
      width="30px"
      height="26px"
      viewBox="0 0 30 26"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Stroke Width</title>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="square"
      >
        <g
          id="画板备份"
          transform="translate(-471.000000, -163.000000)"
          stroke="#7F7F7F"
        >
          <g id="编组-2备份" transform="translate(472.000000, 163.000000)">
            <line
              x1="0.608695652"
              y1="6.94736842"
              x2="27.3913043"
              y2="6.94736842"
              id="直线-6备份"
              strokeWidth="2"
            ></line>
            <line
              x1="5.84713494e-14"
              y1="0.631578947"
              x2="28"
              y2="0.631578947"
              id="直线-6备份-3"
            ></line>
            <line
              x1="1.2173913"
              y1="14.5263158"
              x2="26.7826087"
              y2="14.5263158"
              id="直线-6备份-2"
              strokeWidth="3"
            ></line>
            <line
              x1="1.82608696"
              y1="23.3684211"
              x2="26.173913"
              y2="23.3684211"
              id="直线-6备份-4"
              strokeWidth="4"
            ></line>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Exit</title>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="画板备份"
          transform="translate(-678.000000, -163.000000)"
          fill="#DB311B"
          fillRule="nonzero"
        >
          <g id="关闭备份" transform="translate(678.000000, 163.000000)">
            <path
              d="M23.086649,4.43899758 C24.1957561,3.32989055 24.3094458,1.62959663 23.339293,0.659443783 C22.3691402,-0.310709063 20.667583,-0.197019276 19.5597392,0.912087753 L11.9993684,8.47245856 L4.43899758,0.912087753 C3.32989055,-0.197019276 1.62959663,-0.310709063 0.659443783,0.660707003 C-0.310709063,1.63212307 -0.197019276,3.33241699 0.912087753,4.4402608 L8.47245856,12.0006316 L0.912087753,19.5610024 C-0.197019276,20.6701095 -0.310709063,22.3704034 0.660707003,23.3405562 C1.63212307,24.3107091 3.33241699,24.1970193 4.4402608,23.0879122 L12.0006316,15.5275414 L19.5610024,23.0879122 C20.6701095,24.1970193 22.3704034,24.3107091 23.3405562,23.3405562 C24.3107091,22.3704034 24.1970193,20.6688462 23.0879122,19.5610024 L15.5275414,12.0006316 L23.086649,4.43899758 Z"
              id="路径"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function DrawIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Draw</title>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="画板备份"
          transform="translate(-474.000000, -105.000000)"
          fill="#666666"
          fillRule="nonzero"
        >
          <g id="修改样式备份-2" transform="translate(474.000000, 105.000000)">
            <path
              d="M13.4036565,19.2831945 C13.033014,19.5615052 12.9271162,20.1042109 13.1918608,20.4938458 C13.3507076,20.7443254 13.6154522,20.8695652 13.8669596,20.8695652 C14.0258064,20.8695652 14.1978904,20.8139031 14.3435,20.7164944 C14.8729892,20.3268594 15.1774456,19.6728294 15.1244966,19.0048839 C15.0847849,18.4900091 14.8729892,18.0307966 14.5023467,17.6829083 C14.1317043,17.3489355 13.6684012,17.1819491 13.1786236,17.2236957 C12.688846,17.2654423 12.2520174,17.4880908 11.9210866,17.8777257 C11.603393,18.2673606 11.4445462,18.7544043 11.4842579,19.269279 C11.5107324,19.7284915 11.8813749,20.0763799 12.3049663,20.0763799 L12.3579152,20.0763799 C12.8079811,20.0485488 13.1521491,19.6310828 13.1256747,19.1440392 C13.1256747,19.088377 13.1521491,19.0327149 13.1653864,19.0048839 C13.1786236,18.9770528 13.2183353,18.9492217 13.2845214,18.9492217 C13.3374704,18.9492217 13.3904193,18.9770528 13.4168938,18.9909683 C13.4433682,19.0187994 13.4698427,19.0466304 13.4698427,19.1162081 C13.4830799,19.2275324 13.430131,19.269279 13.4036565,19.2831945 L13.4036565,19.2831945 Z"
              id="路径"
            ></path>
            <path
              d="M21.3779678,4.46066135 L23.048658,1.57354618 C23.2814591,1.16305587 23.1445173,0.643101482 22.7336918,0.410490308 C22.3228664,0.177879133 21.8024875,0.314709236 21.5696864,0.725199544 L20.1591857,3.16077537 L19.282758,4.67958951 L14.3939351,13.1493729 C14.161134,13.5598632 14.2980759,14.0798176 14.7089013,14.3124287 C15.1197268,14.5450399 15.6401057,14.4082098 15.8729068,13.9977195 L20.4604577,6.06157355 C21.7750991,7.90877993 22.4187256,10.1391106 22.3228664,12.4378563 C22.2680896,13.6830103 21.9668176,14.9007982 21.4190504,16.0775371 C20.8849773,17.2269099 20.1591857,18.2668187 19.2416755,19.1835804 C18.3241653,20.1003421 17.2834075,20.8255416 16.1467904,21.359179 C14.9690908,21.9064994 13.7503086,22.2075257 12.5041381,22.2622577 C12.3398079,22.2759407 12.1891719,22.2759407 12.0248417,22.2759407 C10.8334479,22.2759407 9.66944243,22.0706956 8.54651953,21.6738883 C8.27263589,21.5781072 8.16308244,21.359179 8.10830571,21.2497149 C8.06722317,21.1265678 8.01244644,20.8939567 8.16308244,20.6339795 L9.66944243,18.0205245 C10.5458701,16.5017104 10.0254912,14.5587229 8.50543698,13.6966933 C8.02614062,13.4230331 7.47837335,13.27252 6.9169119,13.27252 C5.793989,13.27252 4.739537,13.8745724 4.16438137,14.8597491 L3.3153421,16.3375143 C3.24687119,16.4606613 3.13731774,16.5290764 2.98668174,16.5290764 C2.87712828,16.5290764 2.72649228,16.4880274 2.65802138,16.3238312 C2.11025411,15.1334094 1.79528793,13.8608894 1.72681702,12.5336374 C1.65834611,11.0969213 1.87745302,9.70125428 2.38413774,8.37400228 C2.87712828,7.10148233 3.60291992,5.93842645 4.56151264,4.9395667 C5.52010536,3.94070696 6.64302827,3.14709236 7.90289299,2.58608894 C9.20384025,2.01140251 10.5869526,1.72405929 12.0111475,1.72405929 C12.2165602,1.72405929 12.4356671,1.72405929 12.6410799,1.7377423 C13.9968039,1.81984036 15.3114453,2.16191562 16.5165333,2.75028506 L16.7630286,2.87343216 C17.173854,3.09236032 17.6668446,2.94184721 17.8996457,2.54503991 C18.1461409,2.12086659 17.9818108,1.58722919 17.5572911,1.35461802 C16.1057079,0.602052452 14.4761002,0.123147092 12.7369391,0.0273660205 C12.4904439,0.0136830103 12.2439486,0 12.0111475,0 C5.21883336,0 -0.327310246,5.71949829 0.0150442976,12.6020525 C0.0972093882,14.1755986 0.480646477,15.6670468 1.09688466,17.0216648 C1.46662756,17.8152794 2.21980756,18.2257697 2.98668174,18.2257697 C3.68508501,18.2257697 4.39718246,17.8836944 4.79431373,17.1858609 L5.643353,15.7080958 C5.91723663,15.2428734 6.39653299,14.9828962 6.90321772,14.9828962 C7.14971299,14.9828962 7.38251408,15.0376283 7.61531517,15.1607754 C8.32741262,15.5575827 8.56021371,16.4743444 8.14938826,17.1858609 L6.64302827,19.7856328 C5.88984827,21.0992018 6.49239227,22.7822121 7.93028135,23.3021665 C9.19014607,23.7537058 10.5595642,24 11.9837591,24 C12.1617835,24 12.3535021,24 12.5315264,23.986317 C18.529578,23.7126568 23.7059787,18.5404789 23.9798624,12.5473204 C24.1578867,9.4686431 23.1445173,6.64994299 21.3779678,4.46066135 L21.3779678,4.46066135 Z"
              id="路径"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function RecordIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Record</title>
      <defs>
        <linearGradient
          x1="-3.28764793e-12%"
          y1="3.4139358e-13%"
          x2="100%"
          y2="100%"
          id="linearGradient-1"
        >
          <stop stopColor="#C39084" offset="0%"></stop>
          <stop stopColor="#FF290E" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="画板备份" transform="translate(-516.000000, -163.000000)">
          <g id="编组备份" transform="translate(516.000000, 163.000000)">
            <rect
              id="矩形备份-11"
              fill="#7F7F7F"
              x="0"
              y="0"
              width="24"
              height="24"
              rx="4"
            ></rect>
            <rect
              id="矩形备份-11"
              fill="url(#linearGradient-1)"
              x="3.75"
              y="3.75"
              width="16.5"
              height="16.5"
              rx="8"
            ></rect>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function RedoIcon() {
  return (
    <svg
      width="26px"
      height="24px"
      viewBox="0 0 26 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Redo</title>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="画板备份"
          transform="translate(-598.000000, -163.000000)"
          fill="#7F7F7F"
          fillRule="nonzero"
        >
          <path
            d="M611.827439,169.944289 L611.804001,164.99455 C611.804001,163.159153 610.479707,162.436661 609.350738,163.482254 L598.84624,173.18877 C597.71727,174.229875 597.71727,175.935134 598.850146,176.97624 L609.272608,186.58403 C610.401578,187.625135 611.956353,186.56608 611.956353,185.017884 L611.956353,179.839281 L612.975942,179.839281 C617.534792,179.839281 621.01155,182.100993 623.140577,186.467354 C623.558569,187.261646 624,187.086633 624,186.467354 C623.906245,178.690474 618.413748,169.948777 611.827439,169.948777 L612.018857,169.948777 L611.827439,169.944289 Z"
            id="路径备份-3"
            transform="translate(611.000000, 175.000000) scale(-1, 1) translate(-611.000000, -175.000000) "
          ></path>
        </g>
      </g>
    </svg>
  );
}

export function TrashIcon() {
  return (
    <svg
      width="22px"
      height="24px"
      viewBox="0 0 22 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Clear</title>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="画板备份"
          transform="translate(-640.000000, -163.000000)"
          fill="#7F7F7F"
          fillRule="nonzero"
        >
          <g id="删除备份" transform="translate(640.000000, 163.000000)">
            <path
              d="M2.1388889,4.8 L0.916666667,4.8 C0.410405646,4.8 0,4.39705628 0,3.90000001 C0,3.40294373 0.410405646,3.00000001 0.916666667,3.00000001 L21.0833333,3.00000001 C21.5895944,3.00000001 22,3.40294373 22,3.90000001 C22,4.39705628 21.5895944,4.8 21.0833333,4.8 L3.97222223,4.8 L3.97222223,20.7 C3.97222222,21.0978247 4.13318406,21.4793556 4.41969797,21.7606602 C4.70621188,22.0419647 5.09480814,22.2 5.5,22.2 L16.5,22.2 C16.9051919,22.2 17.2937881,22.0419647 17.580302,21.7606602 C17.8668159,21.4793556 18.0277778,21.0978247 18.0277778,20.7 L18.0277778,7.50000001 C18.0277778,7.00294373 18.4381834,6.6 18.9444444,6.6 C19.4507055,6.6 19.8611111,7.00294373 19.8611111,7.50000001 L19.8611111,20.7 C19.8611111,22.5225 18.35625,24 16.5,24 L5.5,24 C3.64375,24 2.1388889,22.5225 2.1388889,20.7 L2.1388889,4.8 Z M8.55555557,1.8 C8.04929454,1.8 7.6388889,1.39705627 7.6388889,0.899999999 C7.6388889,0.402943725 8.04929454,0 8.55555557,0 L13.4444444,0 C13.9507055,0 14.3611111,0.402943725 14.3611111,0.899999999 C14.3611111,1.39705627 13.9507055,1.8 13.4444444,1.8 L8.55555557,1.8 L8.55555557,1.8 Z M7.6388889,9.89999999 C7.6388889,9.40294372 8.04929454,8.99999999 8.55555557,8.99999999 C9.06181659,8.99999999 9.47222223,9.40294372 9.47222223,9.89999999 L9.47222223,17.1 C9.47222223,17.5970563 9.06181659,18 8.55555557,18 C8.04929454,18 7.6388889,17.5970563 7.6388889,17.1 L7.6388889,9.89999999 Z M12.5277778,9.89999999 C12.5277778,9.40294372 12.9381834,8.99999999 13.4444444,8.99999999 C13.9507055,8.99999999 14.3611111,9.40294372 14.3611111,9.89999999 L14.3611111,17.1 C14.3611111,17.5970563 13.9507055,18 13.4444444,18 C12.9381834,18 12.5277778,17.5970563 12.5277778,17.1 L12.5277778,9.89999999 Z"
              id="形状"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function UndoIcon() {
  return (
    <svg
      width="26px"
      height="24px"
      viewBox="0 0 26 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Undo</title>
      <g
        id="页面-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="画板备份"
          transform="translate(-556.000000, -163.000000)"
          fill="#7F7F7F"
          fillRule="nonzero"
        >
          <path
            d="M569.827439,169.944289 L569.804001,164.99455 C569.804001,163.159153 568.479707,162.436661 567.350738,163.482254 L556.84624,173.18877 C555.71727,174.229875 555.71727,175.935134 556.850146,176.97624 L567.272608,186.58403 C568.401578,187.625135 569.956353,186.56608 569.956353,185.017884 L569.956353,179.839281 L570.975942,179.839281 C575.534792,179.839281 579.01155,182.100993 581.140577,186.467354 C581.558569,187.261646 582,187.086633 582,186.467354 C581.906245,178.690474 576.413748,169.948777 569.827439,169.948777 L570.018857,169.948777 L569.827439,169.944289 Z"
            id="路径备份-2"
          ></path>
        </g>
      </g>
    </svg>
  );
}
